// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ql-9";
export var arrowButtonContainer = "_ql-5";
export var arrowButtonIcon = "_ql-6";
export var carouselArrowButton = "_ql-2";
export var carouselElementContainer = "_ql-1";
export var currentSlide = "_ql-8";
export var left = "_ql-3";
export var otherSlide = "_ql-a";
export var productCarouselContainer = "_ql-0";
export var right = "_ql-4";
export var sliderOverflow = "_ql-7";